// extracted by mini-css-extract-plugin
export var container = "d_g";
export var info = "d_h";
export var floatingDownload = "d_j";
export var qrCode = "d_k";
export var qrIcon = "d_l";
export var topIcon = "d_m";